/* ============================================================
   RAUMGOLD Shopify-Theme – Interaktionen
   (Navigation, Galerie, Einblend-Animationen)
   ============================================================ */

(function () {
  // Kopfzeile: Hintergrund beim Scrollen
  var head = document.getElementById("siteHead");
  var onScroll = function () {
    if (head) head.classList.toggle("scrolled", window.scrollY > 30);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // Navigations-Menü (fährt links ein)
  var navToggle = document.getElementById("navToggle");
  var mainNav = document.getElementById("mainNav");
  var navOverlay = document.getElementById("navOverlay");
  var navZu = function () {
    if (!mainNav) return;
    mainNav.classList.remove("open");
    if (navOverlay) navOverlay.hidden = true;
    document.body.classList.remove("nav-open");
    if (navToggle) {
      navToggle.setAttribute("aria-expanded", "false");
      navToggle.textContent = "☰";
    }
  };
  if (navToggle && mainNav) {
    navToggle.addEventListener("click", function () {
      if (mainNav.classList.contains("open")) {
        navZu();
      } else {
        mainNav.classList.add("open");
        if (navOverlay) navOverlay.hidden = false;
        document.body.classList.add("nav-open");
        navToggle.setAttribute("aria-expanded", "true");
        navToggle.textContent = "✕";
      }
    });
    mainNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", navZu);
    });
    if (navOverlay) navOverlay.addEventListener("click", navZu);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mainNav.classList.contains("open")) navZu();
    });
  }

  // Produkt-Galerien (Hauptbild, Miniaturen, Pfeile, Swipe) – funktioniert
  // für jede Galerie auf der Seite (Startseite & Produktseite gleichermaßen)
  document.querySelectorAll(".gallery").forEach(function (gallery) {
    var main = gallery.querySelector(".gallery-main");
    var mainImg = main ? main.querySelector("img") : null;
    var thumbs = gallery.querySelectorAll(".thumb");
    if (!mainImg || !thumbs.length) return;

    function setActive(index) {
      var total = thumbs.length;
      var i = ((index % total) + total) % total;
      var target = thumbs[i];
      var src = target.getAttribute("data-src");
      if (src) mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove("active"); });
      target.classList.add("active");
    }

    function activeIndex() {
      var idx = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains("active")) idx = i; });
      return idx;
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener("click", function () { setActive(i); });
    });

    var prevBtn = main ? main.querySelector(".gallery-arrow.prev") : null;
    var nextBtn = main ? main.querySelector(".gallery-arrow.next") : null;
    if (prevBtn) prevBtn.addEventListener("click", function () { setActive(activeIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { setActive(activeIndex() + 1); });

    if (main) {
      var touchStartX = 0;
      var swipeThreshold = 40;
      main.addEventListener("touchstart", function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      main.addEventListener("touchend", function (e) {
        var diff = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(diff) > swipeThreshold) {
          setActive(activeIndex() + (diff < 0 ? 1 : -1));
        }
      }, { passive: true });
    }
  });

  // Mengen-Auswahl (Plus/Minus) – Produktseite/Startseite (.qty-selector)
  // und Warenkorb (.ci-qty) gleichermaßen
  document.querySelectorAll(".qty-selector, .ci-qty").forEach(function (sel) {
    var input = sel.querySelector("input[type='number']");
    var buttons = sel.querySelectorAll("button");
    var minus = buttons[0];
    var plus = buttons[1];
    if (!input || !minus || !plus) return;
    minus.addEventListener("click", function () { input.stepDown(); });
    plus.addEventListener("click", function () { input.stepUp(); });
  });

  // Sanftes Einblenden beim Scrollen
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

})();